module.exports = __webpack_public_path__ + "img/stock-1.44eb21e9.jpg";